import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { Spin, Menu, Icon, Avatar } from 'antd';

//Connect redux
import { logoutAction } from 'store/auth/action';
import { getAuth } from 'store/auth/selector';
import { connect } from 'react-redux';

import HeaderDropdown from '../HeaderDropdown';
import AvatarPlaceholder from 'assets/img/user.png';
import styles from './index.module.less';

class GlobalHeaderRight extends PureComponent {
  _handleLogout = () => {
    this.props.logout();
  };

  render() {
    const {
      auth: { username },
      onMenuClick,
      theme,
    } = this.props;

    const menu = (
      <Menu className={styles.menu} selectedKeys={['1']} onClick={onMenuClick}>
        <Menu.Item key="logout" onClick={this._handleLogout}>
          <Icon type="logout" />
          <FormattedMessage id="header.account.logout" />
        </Menu.Item>
      </Menu>
    );
    let className = styles.right;
    if (theme === 'dark') {
      className = `${styles.right}  ${styles.dark}`;
    }
    return (
      <div className={className}>
        {username ? (
          <HeaderDropdown overlay={menu}>
            <span className={`${styles.action} ${styles.account}`}>
              <Avatar
                size="small"
                className={styles.avatar}
                src={AvatarPlaceholder}
                alt="avatar"
              />
              <span className={styles.name}>
                <FormattedMessage
                  id="header.account.welcome"
                  values={{
                    username,
                  }}
                />
              </span>
            </span>
          </HeaderDropdown>
        ) : (
          <Spin size="small" style={{ marginLeft: 8, marginRight: 8 }} />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  auth: getAuth(state),
});
const mapDispatchToProps = {
  logout: logoutAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GlobalHeaderRight);
